export interface WhenCase {
  situation: string;
  response: string;
}

export const WHEN_CASES: readonly WhenCase[] = [
  {
    situation:
      '「AWS の請求書を見ても、何にいくらかかっているのか分からない。」',
    response:
      '請求代行で窓口をまとめることもできます。構成とコストを同じ目で棚卸しし、削れるものと残す理由を見える形にします。',
  },
  {
    situation:
      '「サーバーの保守期限が迫っている。AWS に移したいが、手が足りない。」',
    response:
      '移行計画から実際の移設、切り替え後の運用の整備まで引き受けます。',
  },
  {
    situation: '「デプロイが、特定の人の手作業に頼っている。」',
    response: 'CI/CD を整え、誰が出しても同じ手順で安全に出せる状態にします。',
  },
  {
    situation:
      '「Claude Code や Kiro を入れたいが、チームでの使い方に基準がない。」',
    response:
      '導入設計とルールづくりから、実際に使う場面でのコーチングまで伴走します。',
  },
  {
    situation: '「社内に CTO がいない。技術の判断を相談できる相手がほしい。」',
    response:
      '月額の技術顧問として、設計や投資の判断に外部 CTO の視点で関わります。',
  },
];
